var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoLight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 916,
  height: 916,
  viewBox: "0 0 916 916",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4004_519)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368.944 101.778H152.667C124.562 101.778 101.778 124.562 101.778 152.667V368.944C101.778 397.05 124.562 419.833 152.667 419.833H368.944C397.05 419.833 419.833 397.05 419.833 368.944V152.667C419.833 124.562 397.05 101.778 368.944 101.778Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M763.333 101.778H547.056C518.95 101.778 496.167 124.562 496.167 152.667V368.944C496.167 397.05 518.95 419.833 547.056 419.833H763.333C791.438 419.833 814.222 397.05 814.222 368.944V152.667C814.222 124.562 791.438 101.778 763.333 101.778Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M368.944 496.167H152.667C124.562 496.167 101.778 518.95 101.778 547.056V763.333C101.778 791.439 124.562 814.222 152.667 814.222H368.944C397.05 814.222 419.833 791.439 419.833 763.333V547.056C419.833 518.95 397.05 496.167 368.944 496.167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M763.333 496.167H547.056C518.95 496.167 496.167 518.95 496.167 547.056V763.333C496.167 791.439 518.95 814.222 547.056 814.222H763.333C791.438 814.222 814.222 791.439 814.222 763.333V547.056C814.222 518.95 791.438 496.167 763.333 496.167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458 527.972C496.645 527.972 527.972 496.645 527.972 458C527.972 419.355 496.645 388.028 458 388.028C419.355 388.028 388.028 419.355 388.028 458C388.028 496.645 419.355 527.972 458 527.972Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4004_519"
}, /*#__PURE__*/React.createElement("rect", {
  width: 916,
  height: 916,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "acc460c1f92959c5554e3221c16b1d51.svg";